import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Typography } from '@mui/material';

import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';

const ZSRepresentativesForm = ({ formik }) => (

  <Stack direction="row" justifyContent="space-between" m={2} spacing={2}>
    <Card style={{ flex: '1 1 50%' }}>
      <CardHeader title="Dane osoby uprawnionej do podpisania umowy" sx={{ mt: -1 }} />
      <CardContent>
        <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1}>
          <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
            <Typography variant="subtitle2">Imię</Typography>
            <SmallFormTextField
              error={formik.errors.agreement_signer_name && formik.touched.agreement_signer_name}
              name="agreement_signer_name"
              placeholder="nazwa"
              value={formik.values.agreement_signer_name}
              onChange={formik.handleChange}
              helperText={formik.errors.agreement_signer_name}
            />
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
            <Typography variant="subtitle2">Nazwisko</Typography>
            <SmallFormTextField
              error={formik.errors.agreement_signer_surname && formik.touched.agreement_signer_surname}
              name="agreement_signer_surname"
              placeholder="nazwisko"
              value={formik.values.agreement_signer_surname}
              onChange={formik.handleChange}
              helperText={formik.errors.agreement_signer_surname}
            />
          </Stack>
        </Box>
      </CardContent>
    </Card>
    <Card style={{ flex: '1 1 50%' }}>
      <CardHeader title="Dane osoby reprezentującej szkołe w kontaktach z biurem" sx={{ mt: -1 }} />
      <CardContent>
        <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1}>
          <Stack spacing={1} flex="1 1 50%">
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Imię</Typography>
              <SmallFormTextField
                error={formik.errors.office_representative_name && formik.touched.office_representative_name}
                name="office_representative_name"
                placeholder="nazwa"
                value={formik.values.office_representative_name}
                onChange={formik.handleChange}
                helperText={formik.errors.office_representative_name}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Nazwisko</Typography>
              <SmallFormTextField
                error={formik.errors.office_representative_surname && formik.touched.office_representative_surname}
                name="office_representative_surname"
                placeholder="nazwisko"
                value={formik.values.office_representative_surname}
                onChange={formik.handleChange}
                helperText={formik.errors.office_representative_surname}
              />
            </Stack>
          </Stack>
          <Stack spacing={1} flex="1 1 50%">
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Telefon</Typography>
              <SmallFormTextField
                name="office_representative_phone"
                placeholder="telefon"
                value={formik.values.office_representative_phone}
                onChange={formik.handleChange} />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Dodatkowy telefon</Typography>
              <SmallFormTextField
                name="office_representative_additional_phone"
                placeholder="telefon"
                value={formik.values.office_representative_additional_phone}
                onChange={formik.handleChange} />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">E-mail</Typography>
              <SmallFormTextField
                error={formik.errors.office_representative_correspondence_email && formik.touched.office_representative_correspondence_email}
                name="office_representative_correspondence_email"
                placeholder="e-mail"
                value={formik.values.office_representative_correspondence_email}
                onChange={formik.handleChange}
                helperText={formik.errors.office_representative_correspondence_email}
              />
            </Stack>
          </Stack>
        </Box>
      </CardContent>
    </Card>
  </Stack>
);

export default ZSRepresentativesForm;
